import { Box, Tooltip } from '@mui/material';
import { Chip } from '@molecules';
import { formatDate, parseAmount } from '@utils';
import styles from './styles';

type variantType = 'primary' | 'success' | 'error' | 'warning' | 'default' | 'secondary' | 'info';
type statusType = 'pending' | 'completed' | 'failed';

export const STATUSES: Record<statusType, { label: string; color: variantType }> = {
  pending: {
    label: 'COMMON:PENDING',
    color: 'warning',
  },
  completed: { label: 'COMMON:COMPLETED', color: 'success' },
  failed: {
    label: 'COMMON:FAILED',
    color: 'error',
  },
};

export interface DispersionReport {
  product: string;
  category: string;
  date: string;
  cuil: string;
  amount: number;
  status: statusType;
  area: string;
  description: string;
  executedBy: string;
}

export const DEFAULT_ROWS_PER_PAGE = 25;

/**
 * Returns the table columns
 * @param {boolean} showAreaFeature - Should show area feature or not.
 * @returns Array of table columns
 */
export const buildColumnsForConsolidatedDispersionsList = (showAreaFeature: boolean) => [
  {
    title: 'COMMON:DATE',
    content: ({ date }: DispersionReport) => formatDate(date),
  },
  {
    title: 'COMMON:AMOUNT',
    content: ({ amount }: DispersionReport) => parseAmount(amount),
  },
  {
    title: 'COMMON:STATUS',
    content: ({ status }: DispersionReport) => {
      const statusProps = STATUSES[status];
      return <Chip {...statusProps} variant='outlined' sx={styles.chip} />;
    },
  },
  {
    title: 'COMMON:CUIL',
    content: ({ cuil }: DispersionReport) => cuil,
  },
  {
    title: 'COMMON:PRODUCT',
    content: ({ product }: DispersionReport) => product,
  },
  {
    title: 'COMMON:CATEGORY',
    content: ({ category }: DispersionReport) => category,
  },
  {
    title: 'COMMON:AREA',
    content: ({ area }: DispersionReport) => area,
    hide: !showAreaFeature,
  },
  {
    title: 'COMMON:DESCRIPTION',
    content: ({ description }: DispersionReport) => (
      <Tooltip title={description} arrow>
        <Box sx={[styles.rowEllipsis]}>{description}</Box>
      </Tooltip>
    ),
  },

  {
    title: 'COMMON:EXECUTED_BY',
    content: ({ executedBy }: DispersionReport) => (
      <Tooltip title={executedBy} arrow>
        <Box sx={[styles.rowEllipsis]}>{executedBy}</Box>
      </Tooltip>
    ),
  },
];
